import { useEffect, useState } from "react"
import { ProductYield } from "../../../state/types"
import { FieldType, FieldValue, Form, FormField, ModalId, O, useUIActions } from "../../../../../features/ui"
import { Product, ProductSelectField, useProductLoaders } from "../../../../products"
import { TableName } from "../../../../../tables"

type Props = {
    filterProducts?: (product: Product) => boolean
    onSubmit: (data: Partial<ProductYield>) => void
}

export const ExcludedProductsForm = (props: Props) => {
    const { filterProducts, onSubmit } = props
    const [products, setProducts] = useState<Product[]>([])
    const [selectedProductId, setSelectedProductId] = useState<O<string>>()
    
    const productLoaders = useProductLoaders()
    const { closeModal } = useUIActions()

    useEffect(() => {
        const loadProducts = async () => {
            const { loadAllProducts } = productLoaders()
            // Un producto archivado ya no forma parte de la lista: no tiene sentido excluirlo
            const activeProducts = (await loadAllProducts()).filter(product => !product.archived)
            const filteredProducts = filterProducts ? activeProducts.filter(filterProducts) : activeProducts
            setProducts(filteredProducts)
        }
        loadProducts()
    }, [])

    const onChangeProduct = (value?: FieldValue) => {
        setSelectedProductId(value as O<string>)
    }

    const fields: FormField[] = [
        {
            name: 'productId',
            type: FieldType.TABLE,
            table: TableName.PRODUCTS,
            label: 'Seleccionar Producto a Excluir',
            loading: products.length === 0,
            render: () => (
                <ProductSelectField
                    productList={products}
                    defaultValue={selectedProductId}
                    showStock={false}
                    onChange={onChangeProduct}
                />
            )
        }
    ]

    const handleSubmit = () => {
        if (!selectedProductId) return
        
        onSubmit({ 
            productId: selectedProductId, 
            isExcluded: true, 
            yield: 0 
        })
        closeModal(ModalId.EXCLUDED_PRODUCTS_FORM)
    }

    const handleCancel = () => closeModal(ModalId.EXCLUDED_PRODUCTS_FORM)

    return (
        <Form
            formId="excluded-product-form"
            fields={fields}
            createMode={true}
            createLabel="Excluir"
            onSubmit={handleSubmit}
            onCancel={handleCancel}
        />
    )
}